export const breakpoints = ['36em', '56em', '76em', '106em']
